const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',

  //swiper
  swiperReinit: 'swiper-reinit',
  swiperAfterInit: 'swiper-afterInit'
};

const BREAKPOINTS = {
  "tablet": 768,
  "desktop": 990,
  "desktop-medium": 1200,
  "desktop-large": 1440
}
